import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { Input, HStack } from '@chakra-ui/react';
import { i18n } from '../../../../i18n/translate.js';

// Table level filtering input
var FilterTableInput = function FilterTableInput(_ref) {
  var initialValue = _ref.value,
    onChange = _ref.onChange,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === undefined ? 500 : _ref$debounce,
    placeholder = _ref.placeholder;
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  useEffect(function () {
    var timeout = setTimeout(function () {
      onChange(value);
    }, debounce);
    return function () {
      return clearTimeout(timeout);
    };
  }, [value]);
  return /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    placeholder: i18n.t(placeholder || 'Search'),
    width: "auto",
    marginBottom: '10px'
  });
};
FilterTableInput.displayName = "FilterTableInput";
// Column level filtering input
var FilterColumnInput = function FilterColumnInput(_ref2) {
  var _table$getPreFiltered, _, _2;
  var column = _ref2.column,
    table = _ref2.table;
  var firstValue = (_table$getPreFiltered = table.getPreFilteredRowModel().flatRows[0]) === null || _table$getPreFiltered === undefined ? undefined : _table$getPreFiltered.getValue(column.id);
  var columnFilterValue = column.getFilterValue();
  return typeof firstValue === 'number' ? /*#__PURE__*/React.createElement(HStack, {
    spacing: 2
  }, /*#__PURE__*/React.createElement(Input, {
    type: "number",
    value: (_ = columnFilterValue === null || columnFilterValue === undefined ? undefined : columnFilterValue[0]) !== null && _ !== undefined ? _ : '',
    onChange: function onChange(e) {
      return column.setFilterValue(function (old) {
        return [e.target.value, old === null || old === undefined ? undefined : old[1]];
      });
    },
    placeholder: "Min",
    htmlSize: 2,
    width: 75
  }), /*#__PURE__*/React.createElement(Input, {
    type: "number",
    value: (_2 = columnFilterValue === null || columnFilterValue === undefined ? undefined : columnFilterValue[1]) !== null && _2 !== undefined ? _2 : '',
    onChange: function onChange(e) {
      return column.setFilterValue(function (old) {
        return [old === null || old === undefined ? undefined : old[0], e.target.value];
      });
    },
    placeholder: "Max",
    htmlSize: 2,
    width: 75
  })) : /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: columnFilterValue !== null && columnFilterValue !== undefined ? columnFilterValue : '',
    onChange: function onChange(e) {
      return column.setFilterValue(e.target.value);
    },
    placeholder: i18n.t('Search'),
    width: "auto"
  });
};
export { FilterColumnInput, FilterTableInput };